import { createServerConfig } from "../serverConfig";
import { addSearchParams } from "../url";
export var ActionKeys;
(function (ActionKeys) {
    ActionKeys["REDIRECT_STOP"] = "REDIRECT/STOP";
    ActionKeys["REDIRECT"] = "REDIRECT/TO";
    ActionKeys["REDIRECT_START"] = "REDIRECT/START";
})(ActionKeys || (ActionKeys = {}));
function createRedirect(programUrl = "") {
    function stopRedirection() {
        return { type: ActionKeys.REDIRECT_STOP };
    }
    function redirect(payload) {
        return {
            type: ActionKeys.REDIRECT,
            payload
        };
    }
    function redirectTo(payload) {
        return {
            type: ActionKeys.REDIRECT_START,
            payload
        };
    }
    function redirectToProgram(program) {
        return {
            type: ActionKeys.REDIRECT_START,
            payload: `${programUrl}/${program}`
        };
    }
    const actions = { stopRedirection, redirectTo, redirectToProgram, redirect };
    const initialState = {
        redirect: false,
        path: "/"
    };
    function reducer(state = initialState, action) {
        switch (action.type) {
            case ActionKeys.REDIRECT:
                return Object.assign({}, state, {
                    redirect: true,
                    path: action.payload
                });
            case ActionKeys.REDIRECT_STOP:
                return Object.assign({}, state, { redirect: false });
            default:
                return state;
        }
    }
    function getPath(state) {
        return state.path;
    }
    function hasToRedirect(state) {
        return state.redirect;
    }
    const redirectToEpic = (action$, store) => {
        return action$.ofType(ActionKeys.REDIRECT_START).map(action => {
            const state = store.getState();
            const config = createServerConfig().selectors.getItem(state.serverConfig);
            const url = addSearchParams(action.payload, {
                scenario: action.payload.scenario,
                workspace: action.payload.workspace
            }, config);
            return redirect(url);
        });
    };
    const selectors = { getPath, hasToRedirect };
    const middleware = [redirectToEpic];
    return { actions, reducer, middleware, selectors };
}
export default createRedirect;
//# sourceMappingURL=index.js.map